import { endOfYear, startOfYear } from "date-fns";
import { ValidationSchema } from "lib";

type SAFTExportForm = {
    from: Date;
    to: Date;
};

// Initial values for the SAF-T form is from start of current year to end of current year.
export const defaultSAFTExportForm: SAFTExportForm = {
    from: startOfYear(new Date()),
    to: endOfYear(new Date()),
};

export const schemaSAFTExportForm: ValidationSchema<SAFTExportForm> = {
    from: { required: true },
    to: { required: true },
};
